import React from "react";

import { InputGroup, EditableText } from "@blueprintjs/core";
import classnames from "classnames";

import { CurrencyInput } from "../../../atoms/CurrencyInput";
import styles from "./VariantsTable.module.scss";
import { Icon } from "../../../atoms/Icon";

function VariantsTable({
  columns,
  rows,
  onChangeInput,
  deleteVariant,
  addVariantOption,
  onChangeVariantOptionTitle,
  getVariantOptionTitle,
  deleteVariantOption,
  isValidatingForms,
  isFieldInvalid,
  duplicateTitleIndicies
}) {
  return (
    <div className={styles.variantTableWrapper}>
      {columns.map((column, columnIndex) => (
        <div
          key={columnIndex}
          className={classnames(
            styles.column,
            column.larger && styles.larger,
            column.variantOption && styles.variantOption
          )}
        >
          <span className={styles.title}>
            {!column.variantOption ? (
              column.title
            ) : (
              <div className={styles.variantOptionHeader}>
                <EditableText
                  placeholder="Option Type"
                  className={classnames(
                    isValidatingForms &&
                      (!getVariantOptionTitle(columnIndex) ||
                        duplicateTitleIndicies.includes(columnIndex)) &&
                      styles.invalid
                  )}
                  onChange={onChangeVariantOptionTitle(columnIndex)}
                  value={getVariantOptionTitle(columnIndex)}
                />
                {(columnIndex !== 3 || columns.length > 4) && (
                  <Icon
                    name="trash"
                    size={10}
                    color="#ced9e0"
                    className={styles.deleteVariantOptionIcon}
                    onClick={deleteVariantOption(columnIndex)}
                  />
                )}
              </div>
            )}
          </span>

          {rows.map((row, rowIndex) => (
            <div key={rowIndex} className={styles.cell}>
              {column.stateKey !== "price" ? (
                <InputGroup
                  {...column}
                  large
                  className={classnames(
                    isValidatingForms &&
                      isFieldInvalid(column, row, rowIndex) &&
                      styles.invalid
                  )}
                  value={row[column.stateKey]}
                  onChange={onChangeInput(column.stateKey, rowIndex)}
                  autocomplete="off"
                />
              ) : (
                <CurrencyInput
                  {...column}
                  large
                  className={classnames(
                    isValidatingForms &&
                      isFieldInvalid(column, row) &&
                      styles.invalid
                  )}
                  value={row.price}
                  onChange={onChangeInput("price", rowIndex)}
                  autocomplete="off"
                />
              )}
            </div>
          ))}
        </div>
      ))}
      <div className={styles.column}>
        <span className={styles.title}>
          <Icon
            name="plus"
            size={22}
            color="#2c2c2c"
            className={styles.addVariantOptionIcon}
            onClick={addVariantOption}
          />
        </span>
        {rows.map((row, rowIndex) => {
          const onlyOneRow = rows.length === 1;
          return (
            <div key={rowIndex} className={styles.cell}>
              <Icon
                name="trash"
                size={18}
                color={onlyOneRow ? "#ced9e0" : "#8a9ba8"}
                className={classnames(
                  styles.deleteVariantIcon,
                  onlyOneRow && styles.disabled
                )}
                onClick={!onlyOneRow && deleteVariant(rowIndex)}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default VariantsTable;
